import { Sidebar } from "$/lib/components";
import Flexbox from "$/lib/components/common/Flexbox";
import { useAuth } from "$/lib/context/AuthContext";
import ProtectedRoute from "$/lib/guard/ProtectedRoute";
import ClientProfileIcon from "$/lib/icons/ClientProfileIcon";
import CustomDashboardIcon from "$/lib/icons/CustomDashboardIcon";
import MarketingPlaceIcon from "$/lib/icons/MarketingPlaceIcon";
import { CLIENT_ROUTES } from "$/lib/utils/constants/routes.constants";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

export const Route = createFileRoute("/_client_layout")({
  component: LayoutComponent,
});

function LayoutComponent() {
  const { user } = useAuth();

  const SIDEBAR_ITEMS = useMemo(
    () => [
      ...(user?.client?.hasWebsiteAccess
        ? [
            {
              label: "Suivi marché",
              href: CLIENT_ROUTES.MARKETING_MONITORING,
              Icon: MarketingPlaceIcon,
            },
            {
              label: "Mon tableau de bord",
              href: CLIENT_ROUTES.DASHBOARD,
              Icon: CustomDashboardIcon,
            },
          ]
        : []),
      {
        label: "Profil",
        href: CLIENT_ROUTES.CLIENT_PROFILE,
        Icon: ClientProfileIcon,
      },
    ],
    [user?.client?.hasWebsiteAccess],
  );

  return (
    <ProtectedRoute layout="client">
      <Flexbox row>
        <Sidebar routes={SIDEBAR_ITEMS} />
        <Flexbox className="w-full items-stretch p-6">
          <Outlet />
        </Flexbox>
      </Flexbox>
    </ProtectedRoute>
  );
}
